import React, { useEffect, useState } from "react";
import "./CollectionBox.css";
import { Link } from "react-router-dom";

const CollectionBox = () => {
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    fetch("https://api.swasthmitra.com/api/collections/get")
      .then((response) => response.json())
      .then((data) => {
        if (data.collections) {
          const sortedCollections = data.collections
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .slice(0, 8);
          setCollections(sortedCollections);
        }
      })
      .catch((error) => console.error("Error fetching collections:", error));
  }, []);

  return (
    <div className="main">
      {/* <p className="collection-heading">Get up to 50% off or more</p> */}
      <p className="collection-heading title-gradient">यहाँ से दवा मंगवाना बहुत आसान है</p>
      <div className="collection-container">
        {collections.length > 0 ? (
          collections.map((collection, index) => (
            <div
              className={`collection-card card-${index}`}
              key={collection._id}
              style={{
                backgroundImage: `url(${collection.imageUrl})`,
              }}
            >
              <div className="collection-overlay">
                {/* <span className="discount-tag">50% OFF</span> */}
                <p className="collection-title">{collection.name}</p>
                <h3 className="collection-description">
                  {collection.description}
                </h3>
                {/* <Link to="/shop" className="collection-link">
                  Shop Now
                </Link> */}
              </div>
            </div>
          ))
        ) : (
          <p>Loading collections...</p>
        )}
      </div>
    </div>
  );
};

export default CollectionBox;
